import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BaseService, RoleService } from '../../../../mesc/mesc.service';
import { FormDialogTemplate } from '../../../../../shared/form-dialog/form-dialog.template';
import { BehaviorSubject, Subject } from 'rxjs';
import { AuthenticationService } from '../../../../../auth.service';
import { takeUntil } from 'rxjs/operators';


const RESTRICTED_CODES: any[] = ['TM', 'PL', 'PTE', 'DES', 'Administrator'];

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent extends DataGridTemplate implements OnInit {
  editForm: FormGroup;
  formDialog: FormDialogTemplate;
  dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  module: any;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly userService: BaseService,
    private readonly roleService: RoleService,
    private readonly authService: AuthenticationService,
  ) {
    super();
  }

  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.dialogTitle.complete();
  }

  ngOnInit() {
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.filterable = 'menu';
    this.sortable = true;
    this.formDialog.setHeight(640);
    this.gridState.sort = [{ dir: 'asc', field: 'Code' }];

    this.editForm = this.formBuilder.group({
      Id: [],
      Code: ['', Validators.compose([Validators.required, Validators.maxLength(32)])],
      Name: ['', Validators.compose([Validators.required, Validators.maxLength(65)])],
      Description: ['', Validators.compose([Validators.maxLength(255)])],
      UserIds: []
    })

    this.formDialog.initilize(this.dialogTitle, this.editForm, this.formDialogTabs);

    this.authService.getActiveModule()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(x => {
        this.module = x;
        if (this.module) {
          this.userService.read(`common/User/GetUsersByModule/${this.module.Id}`)
            .then(response => response.map(i => i.cn = `${i.FirstName} ${i.LastName}`));
          this.refresh();
        }
      });
  }


  read(opts: any): Promise<any> {
    return this.module ?
      opts.force ? this.roleService.read(`/GetByModule/${this.module.Id}`) :
        Promise.resolve(this.roleService.value) : Promise.resolve([]);
  }


  create(parentEditDataItem: any): void {
    this.dialogTitle.next('Role');
    this.editForm.get('Code').enable();
    this.formDialog.isNew = true;
    this.formDialog.next({});
  }


  edit(dataItem: any): void {
    const path = `/GetByRoleId/${this.module.Id}/${dataItem.Id}`;
    this.formDialog.isNew = false;
    this.roleService.read(path)
      .then(x => {
        this.dialogTitle.next(`Role: ${dataItem.Code}`);
        this.formDialog.next(x);
        this.editDataItem = x;
      })

    this.editForm.get('Code').disable();
  }


  save(dataItem: any, isNew: boolean): Promise<any> {
    return this.roleService.save(dataItem, isNew, `/${this.module.Id}`, false);
  }


  delete(dataItem: any): Promise<any> {
    return this.roleService.remove(`/${this.module.Id}/${dataItem.Id}`, false);
  }

  readonly isDisabled = (id: string, dataItem: any): boolean => {
    if (id === 'delete') {
      return RESTRICTED_CODES.some(c => c === dataItem.Code);
    } else {
      return false;
    }
  }

  columns: any[] = [
    {
      field: 'Code',
      title: 'Code',
      width: 200,
    },
    {
      field: 'Name',
      title: 'Name',
      width: 400,
    },
    {
      field: 'Description',
      title: 'Description',
    },
  ]



  formControls = [
    {
      type: 'text',
      title: 'Code',
      name: 'Code',
      invalidText: 'Invalid Input. Name must be between 1 and 32 characters.',
    },
    {
      type: 'text',
      title: 'Name',
      name: 'Name',
      stretch: true,
      invalidText: 'Invalid Input. Name must be between 1 and 65 characters.',
    },
    {
      type: 'textarea',
      title: 'Description',
      name: 'Description',
      stretch: true,
      invalidText: 'Invalid Input. Name must be between 1 and 155 characters.',
    },
    {
      type: "multiselect",
      title: "Users",
      name: "UserIds",
      textField: "cn",
      valueField: "Id",
      service: this.userService,
      stretch: true
    },
  ]

  formDialogTabs = [
    {
      title: "Role",
      selected: true,
      formControls: this.formControls
    },
  ]
}

